// extracted by mini-css-extract-plugin
module.exports = {"DataContainer":"OrderMeta_DataContainer__3X6Sq"};